import type { PublicNavContext } from "../publicNavigation";
import type { NavConfig } from "./types";

/** Company destinations shared by public navigation and the footer. */
export function getCompanyNavConfig(
  ctx: PublicNavContext,
): NavConfig["company"] {
  const { t, isSwedish } = ctx;
  return {
    label: isSwedish ? "Företag" : "Company",
    description: isSwedish
      ? "Teamet, berättelsen och nästa steg"
      : "The team, story, and next steps",
    items: [
      {
        label: t("nav.about", isSwedish ? "Om oss" : "About us"),
        href: isSwedish ? "/om-oss" : "/en/about",
        description: t("nav.aboutDescription", "Our mission and story"),
      },
      {
        label: t("nav.press", "Press"),
        href: isSwedish ? "/om-oss/press" : "/en/about/press",
        description: t(
          "nav.pressDescription",
          "Press materials and media resources",
        ),
      },
      {
        label: t("nav.careers", isSwedish ? "Karriär" : "Careers"),
        href: isSwedish ? "/karriar" : "/en/careers",
        description: t(
          "nav.careersDescription",
          "Join the future of home care",
        ),
      },
      {
        label: t("nav.faq", isSwedish ? "Vanliga frågor" : "FAQ"),
        href: isSwedish ? "/vanliga-fragor" : "/en/faq",
        description: t("nav.faqDescription", "Frequently asked questions"),
      },
      getContactNavItem(ctx),
    ],
  };
}

/** Shared contact destination for the About menu and Company footer column. */
export function getContactNavItem({ t, isSwedish }: PublicNavContext) {
  return {
    label: t("nav.contact", isSwedish ? "Kontakta oss" : "Contact us"),
    href: isSwedish ? "/kontakt" : "/en/contact",
    description: t(
      "nav.contactDescription",
      isSwedish ? "Kom i kontakt med oss" : "Get in touch with us",
    ),
  };
}
